import { WithStyles, withStyles } from '@mui/styles';
import { FirmRecord } from '@tassat/fred-definitions';

import { FirmWithdrawal } from './firmWithdrawal';
import { muiStyles } from './firmWithdrawalStyles';

export interface IFirmWithdrawalProps extends WithStyles<typeof muiStyles> {
    firm: FirmRecord;
}

export default withStyles(muiStyles)(FirmWithdrawal);